const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-count',
    selector: '#cart-counter',
  },
  {
    id: '#cart-price',
    section: 'cart-price',
    selector: '#cart-price',
  },
];

class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector('[name="add"]');
    this.popup = document.querySelector('.product-popup');
    this.overlay = document.querySelector('.engo-popup');
    this.closeBtn = this.popup.querySelector('.btn');
    this.closePopup = this.popup.querySelector('.close-window');
    [this.closeBtn, this.closePopup]
      .forEach(btn => {
        btn.addEventListener('click', () => {
          this.popup.classList.remove('active');
        })
      });
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent,
    );
    this.addEventListener('change', this.onVariantChange);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.getSectionsToRender().map((section) => section.section),
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.renderContents(response);
        
        let money = response.price / 100;
        let price = `$ ${money}`;
        let totalPrice = `$ ${(money * response.quantity).toFixed(2)}`;
        let finalPrice = document.querySelector(".js-cart-price");

        this.popup.querySelector('.product-name').textContent = `${response.product_title} - ${response.variant_title ? response.variant_title : ''}`;  
        this.popup.querySelector('.product-price').textContent = price; 
        this.popup.querySelector('.product-qty').textContent = response.quantity; 
        this.popup.querySelector('.product-total').textContent = totalPrice; 
        this.popup.querySelector('.product-image img').setAttribute("src", response.featured_image.url);
        this.popup.querySelector('.product-total-cart').textContent = finalPrice.textContent;

        this.popup.classList.add('active');
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  renderContents(response) {
    
    let cartcount = document.querySelector('#cart-counter').innerHTML;
    if(cartcount != ''){
      cartcount = parseInt(cartcount) + parseInt(response.quantity);
    } else {
      cartcount = parseInt(response.quantity);
    }
    document.querySelector('#cart-counter').innerHTML = cartcount;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      /*sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );*/
    });
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    /*return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;*/

    let parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    let selectedElement = parsedHTML.querySelector(selector);
  
    if (selectedElement) {
      return selectedElement.innerHTML;
    } else {
      // Handle the case where the selector is not found, return an appropriate value or throw an error.
      console.error(`Element with selector '${selector}' not found.`);
      return ''; // You can return an empty string or handle it differently based on your needs.
    }
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, '');
    this.handleErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateVariantInput();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => el.value,
    );
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
  }

  toggleAddButton(disable, text) {
    const submitButton = this.querySelector('[name="add"]');

    if (disable) {
      submitButton.setAttribute('disabled', 'disabled');
      if (text) submitButton.textContent = text;
    } else {
      submitButton.removeAttribute('disabled');
      submitButton.textContent = window.variantStrings.addToCart;
    }
  }
}

customElements.define('product-selector', ProductSelector);
